import React from 'react';
import '../styles/PrivacyPolicy.css';

const PrivacyPolicy = () => {
    return (
        <main>

            <h3 className='privacy-policy-heading'>Privacy Policy</h3>
            
            <div className="privacy-policy">
                <h3>Privacy Policy</h3>
                <p>Last Updated: 12/28/2023</p>
                {/* ...rest of the privacy policy content... */
                    <><p>This Privacy Policy describes how CRAFT - the Social Beer App ("we," "us," or "our") collects, uses, and shares your personal information when you use our mobile application (the "App"). By accessing or using the App, you consent to the practices described in this Privacy Policy.</p>
        
                    <h4>Information We Collect</h4>
                    <p><strong>Information You Provide</strong></p>
                    <p>Account Information: When you register for an account, we collect your username, email address, date of birth, and other information you choose to provide.</p>
                    <p>User Content: You may choose to post text, photos, videos, and other content on the App. This content may be visible to other users of the App.</p>
        
                    <p><strong>Information We Automatically Collect</strong></p>
                    <p>Usage Information: We collect information about your use of the App, including the actions you take within the App, the pages you visit, and the features you use.</p>
                    <p>Device Information: We collect information about your mobile device, including its operating system, device identifiers, and mobile network information.</p>
        
                    <h4>How We Use Your Information</h4>
                    <p>We use the information we collect for various purposes, including:</p>
                    <ul>
                        <li>To provide and maintain the App's functionality.</li>
                        <li>To personalize your experience on the App.</li>
                        <li>To communicate with you, including responding to your inquiries and sending you notifications.</li>
                        <li>To analyze and improve the App's performance and user experience.</li>
                        <li>To enforce our Terms and Conditions and other policies.</li>
                    </ul>
        
                    <h4>Sharing Your Information</h4>
                    <p>We may share your personal information with:</p>
                    <ul>
                        <li>Other Users: Some of your information, such as your username and User Content, may be visible to other users of the App.</li>
                        <li>Service Providers: We may share your information with third-party service providers who assist us in operating the App and providing our services.</li>
                        <li>Legal Compliance: We may disclose your information to comply with legal obligations, protect our rights, and respond to lawful requests.</li>
                    </ul>
        
                    <h4>Your Choices</h4>
                    <p>Account Information: You can review and update your account information in the App's settings. You may also delete your account, but please note that some information may remain in our records even after deletion.</p>
                    <p>Push Notifications: You can opt out of receiving push notifications from the App through your device settings.</p>
        
                    <h4>Security</h4>
                    <p>We take reasonable measures to protect your personal information, but no method of data transmission or storage is entirely secure. We cannot guarantee the security of your information.</p>
        
                    <h4>Children's Privacy</h4>
                    <p>CRAFT - the Social Beer App is intended for users who are of legal drinking age in their respective jurisdictions. We do not knowingly collect or solicit personal information from individuals who are under the legal drinking age. If you are under the legal drinking age, you are not permitted to use our App, and we request that you do not provide any personal information through the App.</p>
                    <p>If you believe that an individual under the legal drinking age has provided us with personal information, please contact us immediately, and we will take appropriate steps to address the situation.</p>
        
                    <h4>Changes to this Privacy Policy</h4>
                    <p>We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the updated Privacy Policy within the App. Your continued use of the App after the posting of changes constitutes your acceptance of those changes.</p>
        
                    <h4>Contact Us</h4>
                    <p>If you have any questions or concerns about this Privacy Policy, please contact us at [Insert Contact Information].</p>
                    </>
                }
                <p>&copy; 2023 CRAFT - the Social Beer App</p>
            </div>
        </main>
    );
};

export default PrivacyPolicy;
